module.exports = __webpack_public_path__ + "img/excel.27cd67cd.svg";